
define('text!templates/filterMenuOptions.html!strip',[],function () { return '{{#options}}\n\t\t<option value="{{code}}" class="{{code}}">{{displayName}}</option>\n\t\t{{/options}}\n\t';});

